<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑故障指导' : '新增故障指导'"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="故障原因" prop="reason">
        <el-input v-model="model.reason" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="解决方案" prop="solution">
        <el-input
            v-model="model.solution"
            type="textarea"
            :rows="2"
            placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name:"FaultGuidanceEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false, 
        model: {
          id: 0,
          faultID: 0,
          rowIndex: 0,
          reason: "",
          solution: "",
        },
        ruleValidate: {
          reason: {required: true, message: "不能为空", trigger: "blur"},
          solution: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(faultID, row) {
        this.dialogVisible = true;
        this.model.faultID = faultID;
        if (row) {
          this.model.id = row.id;
          this.model.rowIndex = row.rowIndex;
          this.model.reason = row.reason;
          this.model.solution = row.solution;
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http.save("basic", "faultGuidances", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>